export default __webpack_public_path__ + "static/media/raw.3df2acef.svg";